import { DEFAULT_USER_IMAGE_URL } from "../app.config";

export const PUBLIC = "PU";
export const MY_CONTACTS = "MC";
export const ONLY_ME = "OM";

const isProfileLoggedInUser = (profile, loggedInUser) => {
  try {
    return profile.id === loggedInUser.id;
  } catch (e) {
    return false;
  }
};

const isProfileAContactOfLoggedInUser = (profile, loggedInUser) => {
  try {
    const matches = loggedInUser.contacts.filter(
      contact => contact.id === profile.id
    );
    return matches.length;
  } catch (e) {
    return false;
  }
};

const _privacyCheck = (
  profile,
  loggedInUser,
  privacyFlag,
  validPayload,
  deniedPayload
) => {
  switch (privacyFlag) {
    case PUBLIC:
      return validPayload;
    case MY_CONTACTS:
      return isProfileAContactOfLoggedInUser(profile, loggedInUser) ||
        isProfileLoggedInUser(profile, loggedInUser)
        ? validPayload
        : deniedPayload;
    case ONLY_ME:
      return isProfileLoggedInUser(profile, loggedInUser)
        ? validPayload
        : deniedPayload;
    default:
      return deniedPayload;
  }
};

export const getFullName = (profile, loggedInUser) => {
  const first_name = _privacyCheck(
    profile,
    loggedInUser,
    profile.first_name_privacy,
    profile.first_name,
    ""
  );

  const last_name = _privacyCheck(
    profile,
    loggedInUser,
    profile.last_name_privacy,
    profile.last_name,
    ""
  );

  return first_name + " " + last_name;
};

export const getAddressField = (
  profile,
  loggedInUser,
  field,
  address = null
) => {
  if (profile.addresses && profile.addresses.length) {
    const _address = address ? address : profile.addresses[0];

    return _privacyCheck(
      profile,
      loggedInUser,
      _address[`${field}_privacy`],
      _address[field],
      ""
    );
  }

  return "";
};

const _formatAddress = addressFieldMap => {
  const fields = [
    "street_number",
    "street",
    "city_district",
    "state_prov",
    "country",
    "postal_zip"
  ];

  let text = "";

  if (addressFieldMap["unit_number"]) {
    text += addressFieldMap["unit_number"] + " -";
  }

  fields.forEach((field, index) => {
    if (field) {
      text += " " + addressFieldMap[field];
    }

    if (
      index + 1 < fields.length &&
      addressFieldMap[field] &&
      fields.slice(index).some(val => addressFieldMap[val])
    ) {
      text += ",";
    }
  });

  return text.replace(/(^[,\s]+)|([,\s]+$)/g, '');
};

export const getFullAddress = (profile, loggedInUser, address) => {
  const result = {};

  [
    "unit_number",
    "street_number",
    "street",
    "city_district",
    "state_prov",
    "country",
    "postal_zip"
  ].forEach(field => {
    result[field] = _privacyCheck(
      profile,
      loggedInUser,
      address[`${field}_privacy`],
      address[field],
      ""
    );
  });

  return _formatAddress(result);
};

export const getEmail = (profile, loggedInUser, emailAddress = null) => {
  const _emailAddress = emailAddress
    ? emailAddress
    : profile.email_addresses[0];

  if (_emailAddress) {
    return _privacyCheck(
      profile,
      loggedInUser,
      _emailAddress.privacy,
      _emailAddress.address,
      ""
    );
  }

  return "";
};

export const getWebsite = (profile, loggedInUser, webAddress = null) => {
  const _webAddress = webAddress ? webAddress : profile.websites[0];

  return _privacyCheck(
    profile,
    loggedInUser,
    _webAddress.privacy,
    _webAddress.address,
    ""
  );
};

export const getContactNumber = (
  profile,
  loggedInUser,
  contactNumber = null,
  type = "phone"
) => {
  const _contactNumber = contactNumber
    ? contactNumber
    : profile[`${type}_numbers`][0];

  if (_contactNumber) {
    return _privacyCheck(
      profile,
      loggedInUser,
      _contactNumber.privacy,
      _contactNumber.number,
      ""
    );
  }

  return "";
};

export const getSocialAccount = (
  profile,
  loggedInUser,
  socialAccount = null
) => {
  return _privacyCheck(
    profile,
    loggedInUser,
    socialAccount.privacy,
    socialAccount,
    null
  );
};

export const getOccupation = (profile, loggedInUser) => {
  return _privacyCheck(
    profile,
    loggedInUser,
    profile.occupation_privacy,
    profile.occupation,
    ""
  );
};

export const getProfDesignations = (profile, loggedInUser) => {
  return _privacyCheck(
    profile,
    loggedInUser,
    profile.prof_des_privacy,
    profile.prof_designations,
    ""
  );
};

export const getWorkPlace = (profile, loggedInUser) => {
  return _privacyCheck(
    profile,
    loggedInUser,
    profile.work_place_privacy,
    profile.work_place,
    ""
  );
};

export const getPhotoUrl = (profile, loggedInUser) => {
  return _privacyCheck(
    profile,
    loggedInUser,
    profile.photo_privacy,
    profile.image_url ? profile.image_url : DEFAULT_USER_IMAGE_URL,
    DEFAULT_USER_IMAGE_URL
  );
};



// WEBPACK FOOTER //
// ./src/utils/profilePrivacy.js